module.exports = __webpack_public_path__ + "img/video-player.d03bbb63.png";